const SettlementSummary = () => {

    return (
        <div className="smt-root">
            {/* Page header */}
            <div className="smt-page-header">
                <div className="smt-page-title-block">
                <div className="smt-page-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="1" y="4" width="22" height="16" rx="2" />
                    <line x1="1" y1="10" x2="23" y2="10" />
                    </svg>
                </div>
                <div> 
                    <h1 className="smt-page-heading">Settlement Summary</h1>
                    <p className="smt-page-sub">Manage settlement summary and settlements details</p>
                </div>
                </div>        
            </div>
            
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');

                .smt-root {
                font-family: 'Plus Jakarta Sans', sans-serif;
                min-height: 100vh;
                display: flex;
                flex-direction: column;
                gap: 20px;
                }
                .smt-page-header {
                display: flex;
                align-items: center;
                justify-content: space-between;
                flex-wrap: wrap;
                gap: 16px;
                }
                .smt-page-title-block { display: flex; align-items: center; gap: 14px; }
                .smt-page-icon {
                width: 44px; height: 44px; border-radius: 12px;
                background: linear-gradient(135deg, #eff6ff, #dbeafe);
                border: 1.5px solid #bfdbfe;
                display: flex; align-items: center; justify-content: center;
                color: #2563eb; flex-shrink: 0;
                }
                .smt-page-heading {
                font-size: 20px; font-weight: 800; color: #0f172a;
                letter-spacing: -0.4px; margin-bottom: 2px; line-height: 22px;
                }
                .smt-page-sub { font-size: 13px; color: #94a3b8; font-weight: 500; }
                .smt-page-actions { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }

                @media (max-width: 600px) {
                .smt-root { padding: 14px; gap: 14px; }
                .smt-page-header { flex-direction: column; align-items: flex-start; }
                }

                .smt-tab-wrap { display:flex; }
                .smt-tab-track {
                position:relative; display:flex;
                background:#f1f5f9; border:1.5px solid #e2e8f0;
                border-radius:12px; padding:4px; gap:0;
                }
                .smt-tab-slider {
                position:absolute; top:4px; bottom:4px;
                width:calc(50% - 4px);
                background:#fff; border-radius:9px;
                box-shadow:0 2px 8px rgba(15,23,42,.1);
                transition:transform .25s cubic-bezier(0.16,1,0.3,1);
                pointer-events:none;
                }
                .smt-tab-btn {
                position:relative;
                display:inline-flex; align-items:center; gap:7px;
                font-family:'Plus Jakarta Sans',sans-serif;
                font-size:13px; font-weight:600; color:#64748b;
                padding:10px 24px; border:none; background:none;
                border-radius:9px; cursor:pointer; transition:color .2s;
                white-space:nowrap;
                }
                .smt-tab-btn--active { color:#2563eb; font-weight:700; }

                .smt-batch-add-grid { display:grid; grid-template-columns:repeat(auto-fill,minmax(240px,1fr)); gap:16px; }

                /* ── Tab toggle ── */
                .po-tab-wrap { display: flex; }
                .po-tab-track {
                position: relative;
                display: inline-flex;   /* was flex + fit-content */
                background: #f1f5f9;
                border: 1.5px solid #e2e8f0;
                border-radius: 12px;
                padding: 4px;
                gap: 0;
                }

                .po-tab-slider {
                position: absolute;
                top: 4px; bottom: 4px;
                left: 4px;
                width: calc(50% - 4px);
                background: #fff;
                border-radius: 9px;
                box-shadow: 0 2px 8px rgba(15,23,42,.1);
                transition: transform .25s cubic-bezier(0.16,1,0.3,1);
                pointer-events: none;
                }

                .po-tab-btn {
                position: relative;
                display: inline-flex;
                align-items: center;
                justify-content: center;
                gap: 7px;
                font-family: 'Plus Jakarta Sans', sans-serif;
                font-size: 13px;
                font-weight: 600;
                color: #64748b;
                padding: 10px 20px;
                border: none;
                background: none;
                border-radius: 9px;
                cursor: pointer;
                transition: color .2s;
                white-space: nowrap;
                flex: 0 0 auto;
                min-width: 190px;   /* forces both buttons to match exactly */
                }

                .po-tab-btn--active { color: #2563eb; font-weight: 700; }
                .po-tab-btn:hover:not(.po-tab-btn--active) { color: #334155; }

                @media (max-width: 600px) {
                .po-tab-wrap {
                    width: 100%;
                }

                .po-tab-track {
                    width: 100%;
                    display: flex;
                }

                .po-tab-btn {
                    flex: 1 1 50%;
                    min-width: 0;
                    width: 50%;
                    padding: 10px 8px;
                    font-size: 10px;
                    gap: 5px;
                    white-space: nowrap;
                }

                .po-tab-slider {
                    width: calc(50% - 4px);
                }
                .po-root { padding: 16px 0; }
                }

                /* ── Content card ── */
                .po-content-card {
                background: #fff;
                border: 1px solid #e2e8f0;
                border-radius: 18px;
                box-shadow: 0 2px 8px rgba(15,23,42,0.06);
                overflow: hidden;
                }

            `}</style>
        </div>
    );

};

export default SettlementSummary;